import React from "react";
import { Link } from "react-router-dom";
import Lottie from "lottie-react";
import phonepeAnimation from "../assets/phonepe.json"

const Footer = () => {
  return (
    <footer className="py-lg-8 py-5 footer-section">
      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-4 col-12">
            <div className="d-flex flex-column gap-4">
              <div></div>
              <div>
                <p className="mb-0 txet-gray-500">
                  Connecting founders and marketers with battle-hardened mentors
                  that genuinely enjoy helping people.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-2 col-md-3 col-6">
            <div className="d-flex flex-column gap-2">
              <h5 className="fw-bold text-white text-uppercase mb-0">
                bsk boutique
              </h5>
              <ul className="footer-collection">
                <li>
                  <Link to="/bsk-about" className="nav-link">
                    About
                  </Link>
                </li>
                <li>
                  <Link to="/bsk-shipping" className="nav-link">
                    Shipping
                  </Link>
                </li>
                {/* <li>
                  <a href="#" className="nav-link">
                    Blog
                  </a>
                </li> */}
                <li>
                  <Link to="/bsk-contact-us" className="nav-link">
                    Contact us
                  </Link>
                </li>
                <li>
                  <Link to="/bsk-fag" className="nav-link">
                    FAQ
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-2 col-md-3 col-6">
            <div className="d-flex flex-column gap-2">
              <h5 className="fw-bold text-white text-uppercase mb-0">
                Support
              </h5>
              <ul className="footer-collection">
                {/* <li>
                  <a href="#" className="nav-link">
                    Track Order
                  </a>
                </li> */}
                <li>
                  <Link to="/bsk-cancel-refund" className="nav-link">
                    Refund & Cancellation
                  </Link>
                </li>
                <li>
                  <Link to="/bsk-terms-condition" className="nav-link">
                    Terms & Conditions
                  </Link>
                </li>
                <li>
                  <Link to="/bsk-privacy-policy" className="nav-link">
                    Privacy policy
                  </Link>
                </li>
                <li>
                  <Link to="/bsk-size-chart" className="nav-link">
                    Size Chart
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-2 col-md-3 col-6">
            <div className="d-flex flex-column gap-2">
              <h5 className="fw-bold text-white text-uppercase mb-0">
                Follow us
              </h5>
              <ul className="d-flex p-0 mt-3">
                {/* <a
                  className="fb-icon text-decoration-none"
                  href={"https://www.facebook.com/bskofcl/"}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fa-brands fa-facebook-f icon-footer"></i>
                </a> */}
                <a
                  className="insta-icon text-decoration-none"
                  href={"https://www.instagram.com/bskboutique?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fa-brands fa-instagram icon-footer"></i>
                </a>

                <a
                  className="whatsapp-icon text-decoration-none"
                  href="https://wa.me/8668160894"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fa-brands fa-whatsapp icon-footer"></i>
                </a>
              </ul>
            </div>
          </div>

          <div className="col-lg-2 col-md-3 col-6">
            <div className="d-flex flex-column gap-2">
              <h5 className="fw-bold text-white text-uppercase mb-0">
                payment
              </h5>
              <div>
                <p className="text-light mb-1" style={{ fontSize: "14px" }}>
                  Secure and fast payments powered by PhonePe.
                </p>
                <div style={{ width: "120px" }}>
                  <Lottie animationData={phonepeAnimation} loop />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-lg-7 mt-5">
          <div className="col-lg-6 offset-lg-3 col-12 text-white">
            <span className="d-flex justify-content-center">
              ©
              <span id="copyright2" className="me-2">
                {new Date().getFullYear()}
              </span>
              BSK Boutique. All Rights Reserved.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
